import React, { useState, useEffect, useCallback } from 'react';
import {
  Box,
  Typography,
  Card,
  CardContent,
  TextField,
  Button,
  Stack,
  Select,
  MenuItem,
  Grid,
  Paper,
} from '@mui/material';
import axios from 'axios';
import { CirclesWithBar } from  'react-loader-spinner'

import { LoadingButton } from '@mui/lab';

export default function Midjourney() {
  const [selectedEmail, setSelectedEmail] = useState('');
  const [selectedCopyTextTone, setSelectedCopyTextTone] = useState('');
  const [selectedTargetAudience, setSelectedTargetAudience] = useState('');
  const [productCollectionName, setProductCollectionName] = useState('');
  const [setTargetAudience] = useState('');
  const [productDescription, setProductDescription] = useState('');
  const [messageId, setMessageId] = useState('');
  const [generatedResponse, setGeneratedResponse] = useState({});

  const [loading, setLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [loadingMessage, setLoadingMessage] = useState(false);
 
  const handleSelectChange = (event) => {
    const { name, value } = event.target;
    if (name === 'email') {
      setSelectedEmail(value);
    } else if (name === 'copyTextTone') {
      setSelectedCopyTextTone(value);
    } else if (name === 'targetAudience') {
      setSelectedTargetAudience(value);
    }
  };

  // posts data to url
  const handleGenerateCopy = async () => {
    const msg = `Email Type: ${selectedEmail}\nCopy Text Tone: ${selectedCopyTextTone}\nTarget Audience: ${selectedTargetAudience}\nProduct/Collection Name: ${productCollectionName}\nProduct/Service Description: ${productDescription}`;

    const data = {
      msg: msg,
      ref: '',
      webhookOverride: '',
      ignorePrefilter: 'false',
    };

    // Replace 'YOUR_OPENAI_API_KEY' with your actual OpenAI API key
    const headers = {
      Authorization: 'Bearer c55beeca-b945-4ca4-aacf-c86b8fcd5976',
      'Content-Type': 'application/json',
    };

    try {
      setLoading(true);
      setIsLoading(true);
      const response = await axios.post('https://api.thenextleg.io/v2/imagine', data, { headers });

      const messageId = response.data.messageId;
      console.log('Message ID:', messageId);

      setMessageId(messageId); // Update the state with the generated messageId

      setLoading(false);
    } catch (error) {
      console.error('Error calling OpenAI API:', error);
      setLoading(false);
    }
  };

  const getMessage = useCallback(async () => {
    if (!messageId) return; // Prevent unnecessary API call

    console.log('Message ID:', messageId);

    const expireMins = 2;
    const headers = {
      Authorization: 'Bearer c55beeca-b945-4ca4-aacf-c86b8fcd5976', // Replace with your actual OpenAI API key
      Accept: 'application/json',
    };

    try {
      const response = await axios.get(`https://api.thenextleg.io/v2/message/${messageId}?expireMins=${expireMins}`, {
        headers,
      });

      setGeneratedResponse(response.data); // Set the response data to the state
    } catch (error) {
      console.error('Error:', error);
    } finally {
      setLoadingMessage(false); // Always set loading state to false after the API call, whether successful or not
    }

    // Call getMessage() after 1 minute and 5 seconds (65000 milliseconds)
    setTimeout(() => {
      getMessage();
      setIsLoading(false); // Hide loading animation after response
    }, 65000);

  }, [messageId]); // messageId is still listed as the dependency for the useCallback

  useEffect(() => {
    if (messageId) {
      getMessage(); // Since we wrapped getMessage in useCallback, we don't need to pass messageId here
    }
  }, [getMessage, messageId]); // Add getMessage and messageId to the dependency array
  useEffect(() => {
    if (messageId) {
      getMessage(messageId); // Pass messageId directly to getMessage
    }
  }, [getMessage, messageId]); // Add getMessage and messageId to the dependency array

 

  return (
    <Box display="flex" flexDirection="column" alignItems="center" marginTop={4}>
      <Typography variant="h5" component="h2">
        Tell us more about your project
      </Typography>
      <Typography
        sx={{
          textAlign: { xs: 'center', sm: 'left' },
          marginTop: '20px',
        }}
      >
        Tell our AI more about your product/email, goal, and target audience language.
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <Card style={{ marginTop: 20 }}>
            <CardContent>
              <Stack direction={{ xs: 'column', md: 'row' }} spacing={2} sx={{ display: 'flex' }}>
                <TextField
                  id="outlined-basic"
                  label="Your Landing Page or Website (example: aithrob.xyz.ai) "
                  variant="outlined"
                  sx={{ width: '100%' }}
                />
                <Button variant="contained" sx={{ width: '100%' }}>
                  Scan My Website
                </Button>
              </Stack>

              <Stack
                direction={{ xs: 'column', sm: 'row' }}
                spacing={2}
                alignItems="center"
                justifyContent="center"
                marginTop={4}
              >
                <Select
                  name="email"
                  value={selectedEmail}
                  onChange={handleSelectChange}
                  variant="outlined"
                  sx={{ width: { xs: '100%', sm: '200px' } }}
                  displayEmpty // Show the first MenuItem as a placeholder
                >
                  <MenuItem value="" disabled>
                    Select Email Type
                  </MenuItem>
                  <MenuItem value="Wekesabuyahi@gmail.com">Wekesabuyahi@gmail.com</MenuItem>
                  <MenuItem value="jim@gmail.com">jim@gmail.com</MenuItem>
                  <MenuItem value="wanjigi@gmail.com">wanjigi@gmail.com</MenuItem>
                  {/* Add more menu items as needed */}
                </Select>

                <Select
                  name="copyTextTone"
                  value={selectedCopyTextTone}
                  onChange={handleSelectChange}
                  variant="outlined"
                  sx={{ width: { xs: '100%' } }}
                  displayEmpty // Show the first MenuItem as a placeholder
                >
                  <MenuItem value="" disabled>
                    Select Copy Text Tone
                  </MenuItem>
                  <MenuItem value="option1">Option 1</MenuItem>
                  <MenuItem value="option2">Option 2</MenuItem>
                  <MenuItem value="option3">Option 3</MenuItem>
                  {/* Add more menu items as needed */}
                </Select>

                <Select
                  name="targetAudience"
                  value={selectedTargetAudience}
                  onChange={handleSelectChange}
                  variant="outlined"
                  sx={{ width: { xs: '100%' } }}
                  displayEmpty // Show the first MenuItem as a placeholder
                >
                  <MenuItem value="" disabled>
                    Target Audience (i.e Returning Customers)
                  </MenuItem>
                  <MenuItem value="professional">Professional</MenuItem>
                  <MenuItem value="creative">Creative</MenuItem>
                  <MenuItem value="casual">Casual</MenuItem>
                  {/* Add more menu items as needed */}
                </Select>
              </Stack>

              <Stack
                direction={{ xs: 'column', sm: 'row' }}
                spacing={2}
                alignItems="center"
                justifyContent="center"
                marginTop={4}
              >
                <TextField
                  id="outlined-basic"
                  name="productCollectionName"
                  label="Product/Collection Name (i.e aithrob.xyz.ai) "
                  variant="outlined"
                  sx={{ width: '100%' }}
                  onChange={(e) => setProductCollectionName(e.target.value)}
                />
                <TextField
                  id="outlined-basic"
                  name="targetAudience"
                  label="Target Audience (i.e Returning Customers) "
                  variant="outlined"
                  sx={{ width: '100%' }}
                  onChange={(e) => setTargetAudience(e.target.value)}
                />
              </Stack>

              <TextField
                id="outlined-multiline-static"
                label={
                  'Product/Service description (i.e aithrob.xyz.ai is an artificial intelligence tool that creates and ' +
                  'designs emails such as flows & campaigns for brands. With aithrob.xyz.ai you can generate ' +
                  'email campaigns and flows within seconds.)'
                }
                multiline
                rows={4}
                variant="outlined"
                fullWidth
                margin="normal"
                onChange={(e) => setProductDescription(e.target.value)}
              />
              <LoadingButton
                loading={loading}
                variant="contained"
                onClick={handleGenerateCopy}
                sx={{
                  width: { xs: '100%', sm: 'auto' },
                  display: 'block',
                  marginLeft: 'auto',
                  marginRight: 'auto',
                  marginTop: '20px',
                  textAlign: { xs: 'center', sm: 'left' },
                }}
              >
                Generate image
              </LoadingButton>

              <Button onClick={getMessage}>Refresh</Button>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} md={6}>
          <Card sx={{ marginTop: 2 }}>
            <CardContent>
              <Typography variant="h5" component="h2" sx={{ textAlign: { xs: 'center', sm: 'left' } }}>
                Generated Image
              </Typography>

              {console.log('loadingMessage:', loadingMessage)}
              {console.log('generatedResponse:', generatedResponse)}

              {generatedResponse.response && Object.keys(generatedResponse.response).length > 0 ? (
                generatedResponse.response.progressImageUrl ? (
                  <img src={generatedResponse.response.progressImageUrl} alt="clickbleman" />
                ) : (
                  <Paper sx={{ p: 2 }}>
                    {generatedResponse.response.imageUrls && (
                      <>
                        <Grid container spacing={2}>
                          {generatedResponse.response.imageUrls.map((imageUrl, index) => (
                            <Grid item key={index} xs={12} md={6} lg={4}>
                              <img
                                src={imageUrl}
                                alt="clickbleman"
                                style={{ width: '100%', height: 'auto', maxHeight: '200px', objectFit: 'cover' }}
                                loading="lazy"
                              />
                            </Grid>
                          ))}
                        </Grid>
                      </>
                    )}
                  </Paper>
                )
              ) : null}
            </CardContent>
            {isLoading && (
              <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
        {/* Show Circle with Bar when isLoading is true */}
        {isLoading && (
          <CirclesWithBar
            height="100"
            width="100"
            color="#2783d6"
            wrapperStyle={{}}
            wrapperClass=""
            visible={true}
            outerCircleColor=""
            innerCircleColor=""
            barColor=""
            ariaLabel="circles-with-bar-loading"
          />
        )}
      </div>
      )}
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
}
